{
  "exitDemoButton": "Quitter la démo",
  "exploreTheAppInDemoMode": "Découvrez l'application FarmHQ à l'aide d'une ferme de démonstration :",
  "indicatorText": {
    "isEnabled": "Mode démo"
  },
  "isActiveText": "Mode démo actif",
  "loadDemoButton": "Charger la démo",
  "permissionDenied": "Cette fonctionnalité est désactivée en mode démo.",
  "toasts": {
    "isEnabled": "Mode démo activé"
  },
  "tryTheDemo": "Essayez la démo",
  "warnings": {
    "someFeaturesDisabled": "Ceci est une démo de l'application FarmHQ. Certaines fonctionnalités sont désactivées."
  }
}
